import * as React from 'react';
import { useDispatch } from 'react-redux';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import { Dispatch } from 'redux';
import { IntlProvider, LocalizationProvider } from '@progress/kendo-react-intl';
import { locales, LocaleInterface } from '../AlertsGrid/GridLocale';

import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { ReportDataSection } from '../../Interfaces/Reports/ReportQueryResult';
import ReportsGrid from './ReportsGrid';

// Styles
const useStyles = makeStyles((theme: Theme) => createStyles({}));

interface Props {
  section: ReportDataSection;
}

const ReportsSection: React.FC<Props> = ({ section }): React.ReactElement => {
  const classes = useStyles();
  const dispatch: Dispatch<any> = useDispatch();

  const [currentLocale, setCurrentLocale] = React.useState<LocaleInterface>(
    locales[0]
  );

  return (
    <React.Fragment>
      <LocalizationProvider language={currentLocale.language}>
        <IntlProvider locale={currentLocale.locale}>
          {section?.Grids?.length > 0
            ? section.Grids.map((g, index) => {
                return <ReportsGrid grid={g} key={index} />;
              })
            : null}
        </IntlProvider>
      </LocalizationProvider>
    </React.Fragment>
  );
};

export default ReportsSection;
